import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { contacts } from '../utils/api';
import { TableProvider } from '../components/shared/table/context/TableContext';
import ContactListTable from '../features/contacts/ContactListTable';

export default function Contacts() {
  const [searchParams] = useSearchParams();
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterType, setFilterType] = useState('');
  const userId = searchParams.get('userId');

  useEffect(() => {
    fetchContacts();
  }, [userId, filterType]);

  const fetchContacts = async () => {
    try {
      const params = {};
      if (userId) {
        params.userId = userId;
      }
      if (filterType) {
        params.type = filterType;
      }
      const response = await contacts.getAll(params);
      setContactList(response || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching contacts:', err);
      setError(err.message || 'Failed to fetch contacts');
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4 h-full flex flex-col">
      <TableProvider type="contact_list" initialState={{ loading, error }}>
        <ContactListTable
          contacts={contactList}
          loading={loading}
          error={error}
          filterType={filterType}
          onFilterTypeChange={setFilterType}
        />
      </TableProvider>
    </div>
  );
}
